import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { navItems } from "@/components/feature/navData";
import { articles } from "@/mocks/news";

const tickerItems = articles.slice(0, 6);

function formatToday() {
  const now = new Date();
  const week = ["日", "一", "二", "三", "四", "五", "六"][now.getDay()];
  return `${now.getFullYear()}.${String(now.getMonth() + 1).padStart(2, "0")}.${String(
    now.getDate(),
  ).padStart(2, "0")} 星期${week}`;
}

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative whitespace-nowrap px-3 py-2 text-sm font-medium transition-colors ${
      isActive
        ? "text-primary-700 after:absolute after:inset-x-3 after:-bottom-0.5 after:h-0.5 after:rounded-full after:bg-primary-500"
        : "text-foreground-700 hover:text-primary-700"
    }`;

  return (
    <header className="sticky top-0 z-50">
      <div className="bg-primary-950 text-background-100">
        <div className="mx-auto flex h-9 max-w-content items-center gap-4 px-4 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 text-xs font-semibold tracking-wide">
            <span className="flex h-4 w-4 items-center justify-center rounded-sm bg-accent-500 text-primary-950">
              <i className="ri-flashlight-fill text-[10px]" aria-hidden="true" />
            </span>
            今日热线
          </span>
          <div className="relative min-w-0 flex-1 overflow-hidden">
            <div className="ticker-track flex w-max items-center">
              {[0, 1].map((group) => (
                <div key={group} className="flex shrink-0 items-center" aria-hidden={group === 1}>
                  {tickerItems.map((item) => (
                    <Link
                      key={`${group}-${item.id}`}
                      to={`/article/${item.id}`}
                      className="mr-8 whitespace-nowrap text-xs text-background-200 transition-colors hover:text-accent-300"
                      tabIndex={group === 1 ? -1 : 0}
                    >
                      {item.title}
                    </Link>
                  ))}
                </div>
              ))}
            </div>
          </div>
          <span className="hidden shrink-0 text-xs text-background-300 lg:block">{formatToday()}</span>
        </div>
      </div>

      <div className="border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-content items-center justify-between gap-4 px-4 md:px-6">
          <Link to="/" className="group flex shrink-0 items-center gap-2.5" title="美日吃瓜 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-goblet-fill text-lg" aria-hidden="true" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
                美日吃瓜
              </span>
              <span className="mt-0.5 text-[10px] tracking-[0.25em] text-foreground-500">
                ENTERTAINMENT
              </span>
            </span>
          </Link>

          <nav className="hidden items-center lg:flex" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/category/idol-meltdown"
              className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              <i className="ri-fire-line" aria-hidden="true" />
              看热榜
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 lg:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
            </button>
          </div>
        </div>

        {menuOpen ? (
          <nav
            className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden"
            aria-label="移动端导航"
          >
            <ul className="flex flex-col">
              {navItems.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    onClick={() => setMenuOpen(false)}
                    className="flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-primary-50 hover:text-primary-700"
                  >
                    {item.label}
                    <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true" />
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        ) : null}
      </div>
    </header>
  );
}